/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_StoryInputs */

const vi_shop_group_story = /** @type {(inputs: Shop_Group_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Câu chuyện dòng chè`)
};

/**

* @param {Shop_Group_StoryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_story = /** @type {((inputs?: Shop_Group_StoryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_StoryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_story(inputs)
});